import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext({
  isOpen: false,
  prompt: "",
  openChat: (initialPrompt: string) => { console.log("Opening chat with prompt:", initialPrompt) },
  closeChat: () => {},
});

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prompt, setPrompt] = useState("");


  const openChat = (initialPrompt: string) => {
    console.log("Opening chat with prompt:", initialPrompt);
    setPrompt(initialPrompt);
    setIsOpen(true);
  };

  const closeChat = () => {
    console.log("Closing chat");
    setIsOpen(false);
    setPrompt("");
  };


  return (
    <ChatContext.Provider value={{ isOpen, prompt, openChat, closeChat }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
